import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import Headline from "../Headline";
import { Spinner, Input } from "@px/px_design_system";
import { UserContext } from "../../context/auth";
import { isEmpty } from "lodash";
import { getEmbedUrl } from "../../../../utils/embedUtils";
import globalConstants from "../../../../global-constants";

import "./style.css";

const VIEW_OPTIONS = [
  { value: "pub_auctionplays", label: "Auction with Plays" },
  { value: "pub_auctions", label: "Auctions" },
  { value: "pub_bidrecords", label: "Bids" },
  { value: "pub_buysidefeesrecords", label: "BuySideFees Records" },
  { value: "pub_deals", label: "Deal Activity" },
  { value: "pub_impressions", label: "Impressions" },
];

const ExploreReporting = ({ history, match }) => {
  const {
    data,
    loading: userLoading,
    isInvalidSuperUser,
  } = useContext(UserContext);
  const { orgData, userData } = data;
  const viewType = match.params.viewType || "pub_auctionplays";
  const [selectedView, setSelectedView] = useState(viewType);
  const [isIframeLoaded, setIframeLoaded] = useState(false);
  const [embedUrl, setEmbedUrl] = useState("");

  // Update selectedView when URL changes
  useEffect(() => {
    if (match.params.viewType && match.params.viewType !== selectedView) {
      setSelectedView(match.params.viewType);
    }
  }, [match.params.viewType]);

  const getEmbedUrlForExplore = async (viewType) => {
    const explore_url = `/embed/explore/pub_views/${viewType}?embed_domain=${window.location.origin}`;

    try {
      const url = await getEmbedUrl({
        userData,
        orgData,
        isInvalidSuperUser,
        embedPath: explore_url,
      });

      if (url) {
        setEmbedUrl(url);
        setIframeLoaded(false);
      }
    } catch (error) {
      console.error("Error getting embed URL:", error);
    }
  };

  // Update iframe URL when selectedView changes
  useEffect(() => {
    if (!isEmpty(orgData) && !userLoading) {
      getEmbedUrlForExplore(selectedView);
    }
  }, [selectedView, orgData, userLoading]);

  const handleViewChange = (event) => {
    const value = event.target.value;
    const selectedOption = VIEW_OPTIONS.find((opt) => opt.label === value);
    if (selectedOption) {
      setSelectedView(selectedOption.value);
      history.push(
        `/orgs/${orgData.id}/reporting/explore/${selectedOption.value}`
      );
    }
  };

  const dropDownProps = {
    dropDownItems: VIEW_OPTIONS.map((option) => option.label),
    selectedValue: VIEW_OPTIONS.find((opt) => opt.value === selectedView)
      ?.label,
  };

  return (
    <>
      <Headline>Explore</Headline>
      <div className="explore-container wrapper">
        <div className="embed--explore__header">
          <strong class="d-block fw-semibold mb-2">
            How to create a Custom Report from Explore:
          </strong>
          <ul class="ps-4 mb-2">
            <li class="mb-1">
              Select a dataset using the dropdown and build your report using
              fields, filters, and visualizations.
            </li>
            <li class="mb-1">
              Click the ⚙️ gear icon and choose <strong>"Save as Look"</strong>{" "}
              or <strong>"Save to Dashboard"</strong>.
            </li>
            <li class="mb-1">
              Visit the <strong>Custom Reports</strong> tab to view and manage
              your saved reports.
            </li>
          </ul>
          <div class="mb-4">
            For more information on deal setup, please see{" "}
            <a
              href={`${globalConstants.HELP_CENTER.explore}`}
              target="_blank"
              class="text-decoration-underline text-primary"
            >
              Creating and Managing Custom Reports with Explore
            </a>{" "}
            in the Help Center
          </div>

          <div className="explore-header form__wrapper">
            <Input
              label="Choose Explore"
              type="select"
              name="select"
              onChange={handleViewChange}
              value={dropDownProps.selectedValue || ""}
            >
              {!isEmpty(dropDownProps) &&
                dropDownProps.dropDownItems.map((org) => {
                  return <option key={org}>{org}</option>;
                })}
            </Input>
          </div>
        </div>
        <div className="explore-embed-container">
          {!isIframeLoaded && (
            <Spinner
              className="spinner-icon"
              color="primary"
              loadingtext="Loading"
              spinnerposition="container"
              data-testid="spinner-loading"
            />
          )}
          {embedUrl && (
            <iframe
              id="embed--reporting"
              className={`explore-iframe ${!isIframeLoaded && "hide"}`}
              src={embedUrl}
              title="Explore Dashboard"
              onLoad={() => setIframeLoaded(true)}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default withRouter(ExploreReporting);
